const DAY_MONTH_YEAR = /^(\d{2})\/(\d{2})\/(\d{4})$/

// the columns that show an amount: they are sorted as numbers, as their cells show them
const AMOUNT_TYPES = ['currency', 'currency_invoicing']

export type SortKey = number | string

/**
 * What a cell is sorted on: its amount for an amount column, its date for a day
 * written DD/MM/YYYY (sorted as text it would put 03/11 before 22/09), else its
 * text. A status is a { value, color }: its text is what counts.
 */
export function sortKey(cell: unknown, columnType?: string | null): SortKey {
  const raw = (cell as { value?: unknown } | null)?.value ?? cell ?? ''

  if (AMOUNT_TYPES.includes(columnType ?? '')) {
    return parseFloat(String(raw)) || 0
  }

  const date = DAY_MONTH_YEAR.exec(String(raw))

  return date ? `${date[3]}-${date[2]}-${date[1]}` : String(raw)
}

export function compareKeys(a: SortKey, b: SortKey): number {
  return typeof a === 'number' && typeof b === 'number'
    ? a - b
    : String(a).localeCompare(String(b))
}
